module.exports = __webpack_public_path__ + "img/clv.61803cdb.svg";